module.exports = __webpack_public_path__ + "static/media/ceklisMovePorto.7641118f.svg";